document.addEventListener('DOMContentLoaded', () => {
  const popin = document.querySelector('.js-popin');
  const popinClose = document.querySelector('.js-popin-close');

  let popinCookie = getCookie('SYM_POPIN');

  if (!popinCookie) {
    setTimeout(function() {
      popin.classList.add('--opened');
    }, 3000);
  }

  popinClose.addEventListener('click', function() {
    popin.classList.remove('--opened');
    var expirationDate = new Date();
    expirationDate.setTime(expirationDate.getTime() + (2 * 24 * 60 * 60 * 1000));
    document.cookie = "SYM_POPIN=1;expires=" + expirationDate.toUTCString() + ";path=/";
  });

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) return match[2];
  }
})